export default __webpack_public_path__ + "static/customerjourneymap-6a276a26a0aa72e96d7e21fc83155c41.png";